import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { ClassId } from '../types';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface LocationState {
  classId: ClassId;
}

const WelcomePage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { classId } = location.state as LocationState;

  const handleEnter = () => {
    navigate('/tools', { state: { classId } });
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
          zIndex: 0,
        },
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          zIndex: 2,
          position: 'relative',
          p: 4,
        }}
      >
        <Typography
          variant="h3"
          component="h1"
          sx={{
            mb: 2,
            color: 'white',
            fontWeight: 'bold',
            textShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
            background: 'linear-gradient(45deg, #fff, #f0f0f0)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          환영합니다!
        </Typography>
        
        <Typography
          variant="h6"
          sx={{
            mb: 4,
            color: 'rgba(255, 255, 255, 0.9)',
            fontWeight: 500,
          }}
        >
          {classId} 반 AI 도구 사용 준비 완료
        </Typography>

      <Button
        variant="contained"
        size="large"
        onClick={handleEnter}
          endIcon={<ArrowForwardIcon />}
        sx={{
            fontSize: '1.5rem',
          padding: '20px 40px',
            borderRadius: '24px',
            background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1))',
            backdropFilter: 'blur(20px)',
            border: '2px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
            color: 'white',
            fontWeight: 'bold',
            transition: 'all 0.3s ease',
            '&:hover': {
              background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.2))',
              transform: 'translateY(-2px)',
              boxShadow: '0 12px 40px rgba(0, 0, 0, 0.3)',
            },
            '&:active': {
              transform: 'translateY(0px)',
            },
        }}
      >
        BNV AI TOOLS 입장
      </Button>
      </Box>
    </Box>
  );
};

export default WelcomePage; 